var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDmtFourthStage = function SvgDmtFourthStage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 22v-3c0-1.886 0-2.828-.586-3.414S17.886 15 16 15h-2l-2 2-2-2H8c-1.886 0-2.828 0-3.414.586S4 17.114 4 19v3M16 15v7M8 15v7M15.5 9V7a3.5 3.5 0 1 0-7 0v2a3.5 3.5 0 1 0 7 0M7.5 7.5h9M12 2v1.5"
  })));
};
export default SvgDmtFourthStage;